<template>
    <div class="breadcrumbs-area breadcrumbs-area--light">
        <div class="container">
            <div class="breadcrumbs">
                <slot></slot>              
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Breadcrumb"
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue